import { Checkbox, Form, Input, Select, Upload } from "antd";
import { useHandleImageUpload } from "hooks/useHandleImageUpload";
import ImgCrop from "antd-img-crop";
import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { showAlertAction } from "store/alert";
import { getOrgStaffProfileOrgField } from "utils";
import { getOrgDashboardIdField } from "utils";
import {
  addNewClient,
  getAllunions,
  getStaffsWithParams,
} from "../store/clients";
import { ImageUpload } from "components/ImageUpload";

const Option = Select.Option;

const RegisterClient = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [cos, setCos] = useState([]);
  const [unions, setUnions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageUrl1, setImageUrl1] = useState();
  const [imageUrl2, setImageUrl2] = useState();
  const { user } = useSelector((state) => state.users);

  useEffect(() => {
    setLoading(true);
    const orgType = getOrgStaffProfileOrgField(user?.position);
    const orgIdField = getOrgDashboardIdField(user?.position);
    const orgFieldId = user?.position === "CO" ? user?.id : user?.[orgType]?.id;

    let queryString = "";
    queryString = queryString.concat(`${orgIdField}=${orgFieldId}`);

    if (user?.position === "CO") {
      setCos([user]);
    } else {
      dispatch(getStaffsWithParams(queryString)).then((result) => {
        setCos(result);
      });
    }

    dispatch(getAllunions(queryString)).then((result) => {
      setUnions(result);
    });
    setLoading(false);
  }, []);

  const handleSubmit = async (values) => {
    if (loading) {
      return;
    }
    if (!imageUrl1 && !imageUrl2) {
      dispatch(
        showAlertAction({
          message: "Please upload an image before submitting this form.",
          level: "danger",
          isVisible: true,
        })
      );
      return;
    }

    // User has to pay either registration fee or contribution fee. If they have not paid either, throw an error, to pay contribution or registration fee.
    const hasNotVeriedanyPayment = !values?.has_payed_fee && !values?.has_payed_contributions_fee
    const verifiedButNoAmountAdded = (values?.has_payed_fee && !values?.reg_fee) || (values?.has_payed_contributions_fee && !values?.contribution_fee)

    if (
      hasNotVeriedanyPayment || verifiedButNoAmountAdded
    ) {
      dispatch(
        showAlertAction({
          message: "You need to pay either registration fee or contribution fee before submit",
          level: "danger",
          isVisible: true,
        })
      );
      return;
    }

    await dispatch(
      addNewClient({ 
        ...values,
        reg_fee_payment_date: values?.has_payed_fee ? new Date().toISOString().split('T')[0] : null,
        contribution_fee_payment_date: values?.has_payed_contributions_fee ? new Date().toISOString().split('T')[0] : null,
        image1: imageUrl1, 
        image2: imageUrl2 })
    );
    form.resetFields();
    setLoading(false);
  };

  return (
    <>
      <Container fluid>
        <h3 className="page-title mb-4">Register Client</h3>
        <Form form={form} onFinish={handleSubmit}>
          <Row>
            <Col className="" md="3">
              <Form.Item
                name="title"
                rules={[
                  {
                    required: true,
                    message: "Please provide title",
                  },
                ]}
              >
                <Input
                  placeholder="Title"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="4">
              <Form.Item
                name="surname"
                rules={[
                  {
                    required: true,
                    message: "Please provide surname",
                  },
                ]}
              >
                <Input
                  placeholder="Surname"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="5">
              <Form.Item
                name="firstname"
                rules={[
                  {
                    required: true,
                    message: "Please provide a first name",
                  },
                ]}
              >
                <Input
                  placeholder="First Name"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="6">
              <Form.Item
                name="house_address"
                rules={[
                  {
                    required: true,
                    message: "Please provide house address",
                  },
                ]}
              >
                <Input
                  placeholder="House Adress"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item
                name="office_address"
                rules={[
                  {
                    required: true,
                    message: "Please provide office address",
                  },
                ]}
              >
                <Input
                  placeholder="Office/Business Address"
                  type="text"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="6">
              <Form.Item
                name="phone_number1"
                rules={[
                  {
                    required: true,
                    message: "Please provide phone number 1",
                  },
                ]}
              >
                <Input
                  placeholder="Phone Number 1"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item name="phone_number2">
                <Input
                  placeholder="Phone Number 2"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="6">
              <Form.Item
                name="marital_status"
                rules={[
                  {
                    required: true,
                    message: "Please provide marital status",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select marital Status"
                  optionFilterProp="children"
                  className="custom-input"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  allowClear
                >
                  <Select.Option value="single" key="single">
                    Single
                  </Select.Option>
                  <Select.Option value="married" key="married">
                    Married
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col className="" md="6">
              <Form.Item
                name="number_of_children"
                rules={[
                  {
                    required: true,
                    message: "Please provide number of children",
                  },
                ]}
              >
                <Input
                  placeholder="Number of children"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="4">
              <Form.Item
                name="nin"
                className="mb-3"
                rules={[
                  {
                    required: true,
                    message: "Please provide a valid NIN (11 digits)",
                  },
                  {
                    min: 11,
                    max: 11,
                    message: "Please provide a valid NIN (11 digits)",
                  },
                ]}
              >
                <Input
                  placeholder="Your NIN number"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
            <Col className="" md="4">
              <Form.Item
                name="reg_fee"
                className="mb-3"
              >
                <Input
                  placeholder="Registration Fee"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>

            <Col className="" md="4">
              <Form.Item
                name="contribution_fee"
                className="mb-3"
              >
                <Input
                  placeholder="Contribution Fee"
                  type="number"
                  className="form-control"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col className="" md="4">
              <Form.Item
                name="union_id"
                rules={[
                  {
                    required: true,
                    message: "Please provide a union for this client",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select union"
                  optionFilterProp="children"
                  className="custom-input"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  allowClear
                >
                  {unions?.map((inst) => (
                    <Select.Option value={inst.id} key={inst.id}>
                      {inst.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>

            <Col className="" md="4">
              <Form.Item
                name="co_id"
                rules={[
                  {
                    required: true,
                    message: "Please select a credit officer",
                  },
                ]}
              >
                <Select
                  showSearch
                  placeholder="Select credit officer"
                  optionFilterProp="children"
                  className="custom-input"
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  allowClear
                >
                  {cos?.map((inst) => (
                    <Select.Option value={inst.id} key={inst.id}>
                      {inst.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <ImageUpload
              uploadDir="clients"
              onImageUpload={setImageUrl1}
              onDeleteImage={() => setImageUrl1(undefined)}
            />

            <ImageUpload
              uploadDir="clients"
              onImageUpload={setImageUrl2}
              onDeleteImage={() => setImageUrl2(undefined)}
            />
          </Row>
          
          <Row>
            <Col md="6">
              <Form.Item
                className="d-flex align-items-center checkbox-form-item"
                name="has_payed_fee"
                label="Click to confirm payment of registration fee"
                labelAlign="left"
                valuePropName="checked"
              >
                <Input
                  style={{ width: "initial" }}
                  type="checkbox"
                  className="form-control-checkbox"
                  name="hasPaidRegFee"
                />
              </Form.Item>
            </Col>

            <Col md="6">
              <Form.Item
                className="d-flex align-items-center checkbox-form-item"
                name="has_payed_contributions_fee"
                label="Click to confirm payment of contribution fee"
                labelAlign="left"
                valuePropName="checked"
              >
                <Input
                  style={{ width: "initial" }}
                  type="checkbox"
                  className="form-control-checkbox"
                  name="hasPaidRegFee"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Button
                variant="primary"
                className="px-5"
                type="submit"
                disabled={loading}
              >
                {loading ? "Loading..." : "Submit"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    </>
  );
};

export { RegisterClient };
